import { useQuery } from '@tanstack/react-query';
import getTarget from 'Api/target/getTarget';
import getTargetRequest from './model/request/getTargetRequest';
import getTargetResponse from './model/response/getTargetResponse';

const useGetTarget = (queryParams) => {
  return useQuery({
    queryKey: ['target', queryParams],
    queryFn: async () => {
      const queries = getTargetRequest(queryParams);

      const response = await getTarget(queries);

      const result = getTargetResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetTarget;
